import React from "react";
import styled from "styled-components";

/** Remplace le contenu d'une section dont tous les indicateurs sont masqués */
const AllHiddenNotice = ({ onShow }) => (
    <Wrapper>
        <span>Tous les indicateurs de cette section sont masqués.</span>
        <button type="button" onClick={onShow}>
            Réafficher la section
        </button>
    </Wrapper>
);

export default AllHiddenNotice;

const Wrapper = styled.div`
    border: 1px dashed var(--prh-line-2);
    border-radius: var(--prh-radius);
    padding: 13px 16px;
    font-size: 13px;
    color: var(--prh-muted);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    button {
        background: none;
        border: none;
        padding: 0;
        color: var(--prh-violet);
        font-size: 13px;
        font-family: inherit;
        text-decoration: underline;
        cursor: pointer;
    }
`;
